import AdminBtn from "./AdminBtn";

export default function AdminStatePanel({
  variant = "empty",
  message,
  onRetry,
  retryLabel = "Retry",
  children,
}) {
  return (
    <section className={`admin-console__state admin-console__state--${variant}`} role="status">
      {message ? <p>{message}</p> : null}
      {children}
      {onRetry ? (
        <AdminBtn variant="secondary" onClick={onRetry}>
          {retryLabel}
        </AdminBtn>
      ) : null}
    </section>
  );
}
